import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { GlobalComponent } from "src/app/global-component";
import { TableContactFilter } from "../../contact-list/configs/table-contact-filter-config-enum";
import { CustomStatusTableConfigEnum } from "src/app/core/enums/list-layout/custom-status-table-config-enum";
import { AccountStatus } from "src/app/core/models/members/user/user.model";


export class FileManagementListTableConfig extends TableConfigurationModel {

     constructor() {
        super();
        this.listTitle = "";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {
                dataFieldName: 'fileName',
                title: 'Name',
                sortable: new SortByValuesModel(),
                visible: 'true',
                order: 1,
                width: "500px",
                type: ColumnTypeEnum.Model,
            },

            {
                dataFieldName: 'fileType',
                title: 'Type',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 2,
                width: "150px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'fileSize',
                title: 'Size',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "100px",
                type: ColumnTypeEnum.FileSize
            },
            {
                dataFieldName: 'tags',
                title: 'Tags',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 4,
                width: "120px",
                type: ColumnTypeEnum.StatusCustomArray,
                arrayDelimiter: `,`,
                customStatusClass: {
                    type: '',
                    switchOptions: [
                        { case: CustomStatusTableConfigEnum.CheckFirstCharacter, delimiter: '_', delimiterExceptionWords: [GlobalComponent.defaultTagList[0]], return: 'coloredTextArea purple' }
                    ]
                },
                customStatusText: {
                    type: '',
                    switchOptions: [
                        { case: CustomStatusTableConfigEnum.CheckFirstCharacter, delimiter: '_', delimiterExceptionWords: [GlobalComponent.defaultTagList[0]], return: undefined }
                    ]
                }
            },
            {
                dataFieldName: 'modifiedDate',
                title: 'Modified Date',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 5,
                width: "120px",
                type: ColumnTypeEnum.Date,
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 6,
                width: "140px",
                type: ColumnTypeEnum.Action
            },
        ]

        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search by file name, file type or tags"
        }
        this.actions = [
            {
                visible: 'true', //SecurityOperations.ai.aiDocumentInsights),
                label: 'AI Insights',
                actionId: ActionIdEnum.LoadChat,
                icon: 'AIChatIconLarge',
                inDropdown: false,
                inList: true,
                showBlankIfHidden: true,
                visibleOnValues: ['.pdf', '.doc', '.docx',],
                subStringDataFieldName: 'tags',
                dataFieldName: 'fileExt'
            },
            {
                visible: SecurityOperations.file.fileManager,
                label: 'View',
                actionId: ActionIdEnum.View,
                icon: 'ri-eye-fill',
                inDropdown: true,
                inList: true
            },
            {
                visible: SecurityOperations.file.fileManager,
                label: 'Download',
                actionId: ActionIdEnum.Download,
                icon: 'ri-download-2-line',
                inDropdown: true,
                inList: true
            },
            {
                visible: SecurityOperations.file.fileDelete,
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-delete-bin-fill',
                inDropdown: true,
                inList: false
            },
            {
                visible: 'true', //SecurityOperations.file.fileDelete), //update security
                label: 'Convert to Searchable PDF using OCR',
                actionId: ActionIdEnum.OCR,
                icon: 'ri-character-recognition-line',
                inDropdown: true,
                inList: false,
                color: `blue-color-only`,
                visibleOnValues: ['.pdf'],
                dataFieldName: 'fileExt',

                visibilityByValueIsEnum: false,
                visibilityByContainsSubString: false,
                visibilitySubString: '_ocr',
                subStringDataFieldName: 'tags',

            },
            {
                visible: 'true', //SecurityOperations.file.fileDelete), //update security
                label: 'Create Color Highlighted Keywords PDF',
                actionId: ActionIdEnum.Highlight,
                icon: 'ri-mark-pen-fill',
                inDropdown: true,
                inList: false,
                color: `orange-color-only`,
                visibleOnValues: ['.pdf'],
                dataFieldName: 'fileExt',

                // visibilityByValueIsEnum: false,
                // visibilityByContainsSubString: true,
                visibilitySubString: '_ocr',
                subStringDataFieldName: 'tags',
            },
            {
                visible: 'true', //SecurityOperations.ai.aiDocumentInsights),
                label: 'AI Insights',
                actionId: ActionIdEnum.LoadChat,
                icon: 'AIChatIcon',
                inDropdown: true,
                inList: false,
                visibleOnValues: ['.pdf', '.doc', '.docx',],
                subStringDataFieldName: 'tags',
                dataFieldName: 'fileExt'
            },
            {
                visible: SecurityOperations.ai.loadFileToKnowledgeBase,
                label: 'Load To Knowledge Base',
                actionId: ActionIdEnum.LoadKnowledgeBase,
                icon: 'AIChatIcon',
                inDropdown: true,
                inList: false,
                visibleOnValues: ['.pdf', '.doc', '.docx',],
                visibilityByValueIsEnum: false,
                visibilityByContainsSubString: false,
                visibilitySubString: '_knowledgebase',
                subStringDataFieldName: 'tags',
                dataFieldName: 'fileExt'
            },
            {
                visible: SecurityOperations.ai.loadFileToKnowledgeBase,
                label: 'Delete From KnowledgeBase',
                actionId: ActionIdEnum.UnloadKnowledgeBase,
                icon: 'AIChatIcon',
                inDropdown: true,
                inList: false,
                visibleOnValues: ['.pdf', '.doc', '.docx',],
                visibilityByValueIsEnum: false,
                visibilityByContainsSubString: true,
                visibilitySubString: '_knowledgebase',
                subStringDataFieldName: 'tags',
                dataFieldName: 'fileExt'
            },
            // {
            //     visible: SecurityOperations.ai.loadFileToKnowledgeBase),
            //     label: 'Delete From Vector Storage',
            //     actionId: ActionIdEnum.DeleteVectorStore,
            //     icon: 'AIChatIcon',
            //     inDropdown: true,
            //     inList: false,
            //     visibleOnValues: ['.pdf', '.doc', '.docx',],
            //     visibilityByValueIsEnum: false,
            //     visibilityByContainsSubString: true,
            //     visibilitySubString: '_isVectorized',
            //     subStringDataFieldName: 'tags',
            //     dataFieldName: 'fileExt'
            // },
        ]
        this.buttons = [
            {
                visible: SecurityOperations.file.fileCreate,
                label: "Upload",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default
            },
            {
                visible: SecurityOperations.file.fileCreate,
                label: "Download Selected",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.Download,
                color: "btn-primary",
                icon: "ri-download-2-line",
                type: ButtonTypeEnum.CheckBoxSelected,
            },
            {
                visible: SecurityOperations.file.fileDelete,
                label: undefined,
                iconIsAfterLabel: true,
                action: ButtonIdEnum.Delete,
                color: "btn-primary",
                icon: "ri-delete-bin-fill",
                type: ButtonTypeEnum.CheckBoxSelected,
            }

        ]
    }
}